import * as React from "react";
import generateId from "logic/generateId";
export function isExternalLinkAction(action) {
  return "linkTarget" in action;
}
export function createHandlerFor(dispatch, action, setActionComponents) {
  if ("handler" in action) {
    return action.handler;
  }
  if ("thunk" in action) {
    return async (args) => dispatch(action.thunk(args));
  }
  if (action.component) {
    const ActionComponent = action.component;
    return ({ queryId, field, value, type }) => {
      const id = generateId();
      const onClose = () => setActionComponents(({ [id]: _, ...rest }) => rest);
      const renderedComponent = /* @__PURE__ */ React.createElement(
        ActionComponent,
        {
          key: action.title,
          onClose,
          queryId,
          field,
          value,
          type
        }
      );
      setActionComponents(
        (actionComponents) => ({
          [id]: renderedComponent,
          ...actionComponents
        })
      );
      return Promise.resolve();
    };
  }
  throw new Error(`Invalid binding for action: ${String(action)} - has neither 'handler' nor 'component'.`);
}
